import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import { Link } from 'hb-react/frontoffice/components/Link';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const PostCardCategories = ({ categories }) => {
  const iconProps = {
    className: 'icon-tag',
    'aria-hidden': 'true',
  };

  return (
    <span>
      <span className="soft-quarter--right">
        <i {...iconProps} />
      </span>
      {categories.map((c, i) =>
        i === 0 ? (
          <span key={c.name}>{c.name}</span>
        ) : (
          <span key={c.name}>{` — ${c.name}`}</span>
        ),
      )}
    </span>
  );
};

PostCardCategories.propTypes = {
  categories: PropTypes.array,
};

/**
 * @deprecated - only used on old HAML Public Homepage
 */
const PostCard = ({
  currentUser,
  categories,
  cover_picture: coverPicture,
  customClassNames = 'one-half',
  id,
  indexGrid = false,
  published_at: publishedAt,
  feedable_at: feedableAt,
  subject,
}) => {
  const { topicId, whitelabelURL } = useTopicContext();

  const linkPath =
    topicId && !whitelabelURL ? `/topics/${topicId}/news/${id}` : `/news/${id}`;

  const linkProps = {
    to: linkPath,
    forceDefaultLink: !currentUser,
    'aria-label': `${__('Read more')}: ${subject}`,
    role: 'article',
  };
  const iconProps = {
    className: 'icon-calendar',
    'aria-hidden': 'true',
  };

  return (
    <Link {...linkProps}>
      <div
        className={classNames('grid__item palm--one-whole', customClassNames)}
      >
        <div
          className={classNames(
            'cover-bloc-item--news cover-bloc-item--news-aa',
            {
              'cover-bloc-item--news--index': indexGrid,
            },
          )}
        >
          <div
            className={classNames(
              'cover-bloc-item__image cover-bloc-item__image-aa',
            )}
            style={{ backgroundImage: `url(${coverPicture})` }}
          />
          <div className="cover-bloc-item__footer">
            <div className="cover-bloc-item__info">
              <h4 className="h4" style={{ opacity: 1 }}>
                <Dotdotdot clamp={2}>{subject}</Dotdotdot>
              </h4>
              <div>
                <span className="soft-quarter--right">
                  <i {...iconProps} />
                </span>
                <span className="push-half--right">
                  {moment(feedableAt || publishedAt).format('MMM DD')}
                </span>
                {categories.length > 0 && (
                  <PostCardCategories categories={categories} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

PostCard.propTypes = {
  id: PropTypes.number.isRequired,
  cover_picture: PropTypes.string,
  subject: PropTypes.string,
  published_at: PropTypes.string.isRequired,
  customClassNames: PropTypes.string,
  categories: PropTypes.array,
  indexGrid: PropTypes.bool,
};

export default withDefaultAppContexts(PostCard);
